import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ClienteCadastroPipe, ClienteCadastroColorPipe, ClienteCadastroBadgePipe } from './pipes';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteCadastroPipe,
        ClienteCadastroColorPipe,
        ClienteCadastroBadgePipe
    ],
    exports: [
        SharedModule,

        ClienteCadastroPipe,
        ClienteCadastroColorPipe,
        ClienteCadastroBadgePipe
    ],
    providers: [
        ClienteCadastroPipe,
        ClienteCadastroColorPipe,
        ClienteCadastroBadgePipe
    ]
})
export class ClienteCadastroModule { }
